<template>
  <div id="home" @click="hidWeChatShareQRCode">
    <img src="../assets/images/png/3-e5f9c89c8f.jpg" class="pc-only" alt="" id="long-bg">
    <img src="../assets/images/png/spray--01_2x.png" alt="" class="pc-only" id="left-star">
    <img src="../assets/images/png/spray--02_2x.png" alt="" class="pc-only" id="right-star">
    <img src="../assets/images/mobile/spray--01_2x.png" alt="" class="mobile-only" id="left-star1">
    <img src="../assets/images/mobile/spray--02_2x.png" alt="" class="mobile-only" id="right-star1">
    <img src="../assets/images/mobile/spray--01_2x.png" alt="" class="mobile-only" id="left-star2">
    <img src="../assets/images/mobile/spray--02_2x.png" alt="" class="mobile-only" id="right-star2">
    <img src="../assets/images/png/home.png" alt="" id="bottom-flag">
    <div class="page mobile-only" id="mobile-header">
      <div class="menu-button" @click="showMenu">
        <img src="../assets/images/mobile/Combined Shape.svg" alt="">
      </div>
      <div class="menu-wrapper" v-show="isShowMenu" @click="hideMenu">
        <div @click.stop>
          <div class="page">
            酷公司100
            <div class="menu-button" @click="hideMenu">
              <img src="../assets/images/mobile/Combined Shape.svg" alt="">
            </div>
          </div>
          <a class="menu" @click="anchor('dot1')">点亮</a>
          <a class="menu" @click="anchor('dot2')">助力</a>
          <a class="menu" @click="anchor('dot3')">先导</a>
        </div>
      </div>
    </div>
    <div class="page" id="page1">
      <div class="center-box">
        <div id="man-in-moon">
          <img src="../assets/images/png/2-de01bd49f0.png" alt="" class="pc-only" id="moon">
          <img src="../assets/images/png/img.png" alt="" class="pc-only" id="man">
          <img src="../assets/images/mobile/2-de01bd49f0.png" alt="" class="mobile-only" id="moon-mobile">
          <img src="../assets/images/mobile/img.png" alt="" class="mobile-only" id="man-mobile">
        </div>
        <div id="cool-title">
          <img src="../assets/images/svg/极客公园.svg" alt="" class="geekpark-logo">
          <img src="../assets/images/svg/Group.svg" alt="" class="x-sign">
          <img src="../assets/images/svg/资源 1 copy.svg" alt="" class="thinkpad-logo">
          <img src="../assets/images/svg/Combined Shape.svg" alt="" id="cool-bg">
          <div id="cool-100">酷公司100</div>
          <div id="cool-slogan">极客公园联手ThinkPad推出酷公司计划</div>
        </div>
        <div id="three-point">
          <div class="block left">
            <div class="point">发掘</div>
            <div class="summary">100家酷公司的<br>发展成长道路</div>
          </div>
          <div class="block center">
            <div class="point">赋能</div>
            <div class="summary">thinkplus<br>高效能方案</div>
          </div>
          <div class="block right">
            <div class="point">助力</div>
            <div class="summary">酷公司<br>高效成长</div>
          </div>
        </div>
      </div>
      <dot-progress ref="dot1" class="dot-progress pc-only" id="dot-progress-page1"
                    :data="dotProgressData[0]"></dot-progress>
    </div>
    <div class="page" id="page2">
      <div class="decoration-block1 pc-only">
        <div class="item item1"></div>
        <div class="item item2"></div>
        <div class="item item3"></div>
        <div class="item item4"></div>
      </div>
      <div class="dot-progress-mobile mobile-only" id="dot1">
        <div class="dot"></div>
        点亮
      </div>
      <div class="center-box">
        <div class="left">
          <div class="title">100家酷公司的<br>理想与光芒</div>
          <div class="summary">极客公园联手ThinkPad<br>洞见科技创新企业的高效成长</div>
          <div class="mobile-only articles">
            <a :href="`http://www.geekpark.net/news/${article.id}`" target="_blank"
               v-for="(article, i) in [...topArticles, ...otherArticles.slice(0, 3)]"
               v-bind:key="i">
              <div class="article">
                <img :src="article.authors && article.authors.length > 0 ? article.authors[0].avatar_url : ''" alt=""
                     class="avatar">
                <div class="title">{{article.title}}</div>
                <div class="summary">{{article.abstract}}</div>
                <div class="time">{{article.published_timestamp*1000 | dateformat('MMM DD, YYYY')}}</div>
              </div>
            </a>
          </div>
          <a href="http://www.geekpark.net/topic/274" target="_blank" class="learn-more">查看更多</a>
        </div>
        <div class="right">
          <article-swiper class="pc-only article-swiper" v-if="articles.length > 0"
                          :topArticles="topArticles"
                          :data="[...otherArticles, ...otherArticles, ...otherArticles]"></article-swiper>
        </div>
      </div>
      <dot-progress ref="dot2" class="dot-progress pc-only" id="dot-progress-page2"
                    :data="dotProgressData[1]"></dot-progress>
    </div>
    <div class="page" id="page3">
      <div class="dot-progress-mobile mobile-only" id="dot2">
        <div class="dot"></div>
        助力
      </div>
      <div class="center-box">
        <div class="title">thinkplus高效能方案</div>
        <div id="four-point">
          <div class="block">
            <div class="point">以赋能为核心的价值观</div>
            <div class="summary">极客公园与ThinkPad基于推动企业高效成长的“赋能”价值观，推出thinkplus高效能方案。</div>
          </div>
          <div class="block">
            <div class="point">定制化软硬件综合服务体</div>
            <div class="summary">针对商务个人及SMB公司，办公软硬件成本<br>支出过高的痛点定制，实现高效办公。</div>
          </div>
          <div class="block">
            <div class="point">典型应用场景全覆盖</div>
            <div class="summary">以ThinkPad产品为核心，覆盖商务办公、商旅出行和智享生活场景，提供ThinkPad、选件产品，Think Smart-IoT智能物联产品及thinkplus服务。
            </div>
          </div>
          <div class="block last">
            <div class="point">智能新生态促进共赢共生</div>
            <div class="summary">thinkplus 创业者支持计划”整合设计、供应链、渠道、推广及服务，为与ThinkPad品牌共鸣的创业团队提供智能生态资源。</div>
          </div>
          <div class="clearfix"></div>
        </div>
        <good-card class="good-card" ref="goodcard"></good-card>
      </div>
      <dot-progress ref="dot3" class="dot-progress pc-only" id="dot-progress-page3"
                    :data="dotProgressData[2]"></dot-progress>
    </div>
    <div class="page" id="page4">
      <div class="dot-progress-mobile mobile-only" id="dot3">
        <div class="dot"></div>
        先导
      </div>
      <image-swiper class="image-swiper" :data="[...images, ...images, ...images]"></image-swiper>
      <video-swiper class="video-swiper" :data="videos"></video-swiper>
      <dot-progress ref="dot4" class="dot-progress pc-only" id="dot-progress-page4"
                    :data="dotProgressData[3]"></dot-progress>
    </div>
    <div class="page" id="footer">
      <div class="decoration-block1 pc-only">
        <div class="item item1"></div>
        <div class="item item2"></div>
        <div class="item item3"></div>
        <div class="item item4"></div>
      </div>
      <div class="bg-line"></div>
      <div class="qrcode-wrapper">
        <img src="../assets/images/png/thinkpad-qrcode.png" alt="" class="qrcode">
      </div>
      <div class="triangle-wrapper">
        <img src="../assets/images/svg/Triangle 2.svg" alt="" class="triangle">
      </div>
      <div class="tip">扫描二维码<br>获取thinkplus高效能方案更多内容</div>
      <div class="bottom-slogan">
        <img src="../assets/images/svg/Combined Shape (1).svg" alt="" class="logo">
        100家酷公司的<span class="red">理想与光芒</span>
      </div>
      <div class="social-icon">
        <div class="wechat-block">
          <div class="wechat-qrcode" v-show="isShowWeChatShareQRCode">
            <img src="../assets/images/png/cool100_qrcode.png" alt="">
          </div>
          <img src="../assets/images/png/微信@2x.png" alt="" class="wechat" @click.stop="showWeChatShare()"
               @mouseover="showWeChatShare()" @mouseout="hidWeChatShareQRCode()">
        </div>
        <a
          href="http://service.weibo.com/share/share.php?url=http://www.geekpark.net/zhuanti/cool100/&title=极客公园%20x%20Thinkpad%20%20极客公园联手ThinkPad洞见科技创新企业的高效成长"
          target="_blank">
          <img src="../assets/images/png/微博@2x.png" alt="" class="weibo">
        </a>
      </div>
      <div class="company-logo">
        <img src="../assets/images/svg/极客公园.svg" alt="" class="geekpark-logo">
        <img src="../assets/images/svg/Group.svg" alt="" class="x-sign">
        <img src="../assets/images/svg/资源 1 copy.svg" alt="" class="thinkpad-logo">
      </div>
    </div>
    <!--<swiper id="home-swiper" :options="homeSwiperOption" ref="homeSwiper" @slideChange="slideChange">-->
    <!--<swiper-slide id="page1">-->
    <!--</swiper-slide>-->
    <!--<swiper-slide id="page2">-->
    <!--</swiper-slide>-->
    <!--<swiper-slide id="page3">I'm Slide 3</swiper-slide>-->
    <!--<swiper-slide id="page4">I'm Slide 4</swiper-slide>-->
    <!--</swiper>-->
    <div class="wechat-share-tip" v-show="isShowWeChatShareTip" @click="hidWeChatShareTip">
      <div class="arrow">
        <img src="../assets/images/mobile/554503310680619318.png" alt="">
      </div>
      <div class="content">点击右上角 “ ... ” 分享</div>
    </div>
  </div>
</template>
<script>
import VideoSwiper from '@/components/VideoSwiper'
import ImageSwiper from '@/components/ImageSwiper'
import DotProgress from '@/components/DotProgress'
import GoodCard from '@/components/GoodCard'
import ArticleSwiper from '@/components/ArticleSwiper'
import TestCom from '@/components/TestCom'
import config from '@/config'
import axios from 'axios'

export default {
  name: 'Home',
  components: {VideoSwiper, ImageSwiper, DotProgress, GoodCard, ArticleSwiper, TestCom},
  data () {
    return {
      isShowMenu: false,
      isShowWeChatShareTip: false,
      isShowWeChatShareQRCode: false,
      scrollTop: 0,
      dot1Top: 9999,
      dot2Top: 9999,
      dot3Top: 9999,
      dot4Top: 9999,
      dotProgressData: [
        {index: '01', name: '启动', dotPos: 'up'},
        {index: '02', name: '点亮', dotPos: 'up'},
        {index: '03', name: '助力', dotPos: 'up'},
        {index: '04', name: '先导', dotPos: 'down'}
      ],
      videos: [
        {
          title: 'ThinkPad X280 <br class="mobile-only">带你演绎提案高效派',
          previewUrl: require('../assets/images/png/WechatIMG34@2x.png'),
          videoUrl: 'https://p.bokecc.com/player?vid=A2CF647EA19D65E39C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1'
        },
        {
          title: 'Thinker李昆雁：<br>高效运作，去实现慢生活',
          previewUrl: require('../assets/images/png/PastedGraphic-7@2x.png'),
          videoUrl: 'https://p.bokecc.com/player?vid=7786566C8761D3729C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1'
        },
        {
          title: '折纸艺术家刘通：<br>在创意领域为梦想赋能',
          previewUrl: require('../assets/images/png/PastedGraphic-5@2x.png'),
          videoUrl: 'https://p.bokecc.com/player?vid=B5EED1924C142C5F9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1'
        }
      ],
      images: [
        {
          previewUrl: require('../assets/images/goods/good (1).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (2).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (3).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (4).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (5).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (6).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (7).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (8).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (9).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (10).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        },
        {
          previewUrl: require('../assets/images/goods/good (11).jpg'),
          link: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
        }
      ],
      topArticleIds: [231592, 231590],
      topArticles: [],
      articles: [],
      homeSwiperOption: {
        // basic
        direction: 'vertical',
        // mousewheel
        mousewheel: true
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.homeSwiper.swiper
    },
    otherArticles () {
      // 从articles中去除topArticles
      let topIds = this.topArticleIds
      for (let article of this.topArticles) {
        topIds.push(article.id)
      }
      return this.articles.filter(function (item, index, array) {
        return !(topIds.indexOf(item.id) > -1)
      })
    }
  },
  methods: {
    getTopArticles () {
      /* 获取置顶文章 */

      // 获取一篇文章Task
      function getArticleTask (id) {
        return axios.get(config.ARTICLE_API + '/posts/' + id)
      }

      // 生成需要执行的请求
      let tasks = []
      for (let id of this.topArticleIds) {
        tasks.push(getArticleTask(id))
      }
      // 并发执行所有请求任务
      axios.all(tasks).then(
        axios.spread((...ress) => {
          for (let res of ress) {
            // 将请求成功的置顶文章记录
            if (res.status === 200) {
              this.topArticles.push(res.data.post)
            }
          }
        })
      )
    },
    getArticles () {
      axios.get(config.ARTICLE_API + '/topics/274').then(
        (res) => {
          this.articles = res.data.topic.posts
        }
      )
      // this.articles = [
      //   {
      //     'authors': [
      //       {
      //         'avatar_url': 'http://account-img.geekpark.net/uploads/user/avatar/8c24da29-2616-4fed-bf02-45f910169aba/0.jpeg'
      //       }
      //     ],
      //     'id': 227453,
      //     'title': '投资人对他说：你讲了 5 个多小时，我基本没听懂，但我要给你 1000 万和一间仓库',
      //     'abstract': '本来，他觉得公司能卖 7.75 亿人民币就挺好，如今却发现自己站在了更大的机遇面前。',
      //     'published_timestamp': 1521648000
      //   },
      //   {
      //     'authors': [
      //       {
      //         'avatar_url': 'http://account-img.geekpark.net/uploads/user/avatar/8e855fa7-a30f-4822-90e9-f966cf914cae/132.jpeg'
      //       }
      //     ],
      //     'id': 229001,
      //     'title': '一场由无人驾驶开始的环卫革命',
      //     'abstract': '当「低速无人驾驶更容易落地」成为公开的秘密，这个圈子里还有哪些新鲜事？',
      //     'published_timestamp': 1525968000
      //   },
      //   {
      //     'authors': [
      //       {
      //         'avatar_url': 'http://account-img.geekpark.net/uploads/user/avatar/e0a98095-827d-4630-9d5f-55b6bb9e51c8/2.jpg'
      //       }
      //     ],
      //     'id': 226831,
      //     'title': '飞手再见！真正无人的无人机，和它们布局的「地面卫星」',
      //     'abstract': '无人机真正「无人」，才能发挥最大威力。',
      //     'published_timestamp': 1519315200
      //   },
      //   {
      //     'authors': [
      //       {
      //         'avatar_url': 'http://account-img.geekpark.net/uploads/user/avatar/8c24da29-2616-4fed-bf02-45f910169aba/0.jpeg'
      //       }
      //     ],
      //     'id': 225221,
      //     'title': '解码 VIPKID：这家四年晋升为「10亿美金俱乐部」的教育业另类，到底有何不同？',
      //     'abstract': 'VIPKID的本质不是传统K12教育，而是个性化学习的启蒙。对于这家以产品立命的公司，技术不是装饰，而是未来。',
      //     'published_timestamp': 1513612800
      //   },
      //   {
      //     'authors': [
      //       {
      //         'avatar_url': 'http://account-img.geekpark.net/uploads/user/avatar/25707c07-30fb-4e49-bc8e-545da2750133/0.jpeg'
      //       }
      //     ],
      //     'id': 226855,
      //     'title': '除了「放卫星」，民营航天卫星公司还在做什么？太空教育成了一个新答案',
      //     'abstract': '用更加市场化的方式在商业卫星行业站住脚，是这些公司关于生存的永恒命题。',
      //     'published_timestamp': 1519488000
      //   }
      // ]
    },
    showMenu () {
      this.isShowMenu = true
    },
    hideMenu () {
      this.isShowMenu = false
    },
    anchor (anchorName) {
      this.hideMenu()
      // 找到锚点
      let anchorElement = document.getElementById(anchorName)
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView()
      }
    },
    hidWeChatShareQRCode () {
      this.isShowWeChatShareQRCode = false
    },
    hidWeChatShareTip () {
      this.isShowWeChatShareTip = false
    },
    showWeChatShare () {
      if (this.$device.isWechat()) {
        this.isShowWeChatShareTip = true
      } else if (this.$device.isMobile()) {
        this.isShowWeChatShareQRCode = true
      } else {
        this.isShowWeChatShareQRCode = true
      }
    },
    scroll () {
      // 记录滚动高度
      let clientHeight = document.documentElement.clientHeight
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 根据滚动高度,为 进度点 增加show class
      for (let dot of this.$dots) {
        let dotTop = dot.offsetTop + dot.parentNode.offsetTop
        if (scrollTop > (dotTop - 400) && scrollTop < (dotTop + dot.offsetHeight)) {
          dot.classList.add('show')
        } else {
          dot.classList.remove('show')
        }
      }
      // 根据滚动高度, 为good card增加active class
      for (let card of this.$mobilecards) {
        let cardTop = card.offsetTop
        let cur = card.offsetParent
        while (cur != null) {
          cardTop += cur.offsetTop
          cur = cur.offsetParent
        }
        if (scrollTop > (cardTop - clientHeight / 2) && scrollTop < (cardTop + card.offsetHeight - clientHeight / 2)) {
          card.classList.add('mobile-center')
        } else {
          card.classList.remove('mobile-center')
        }
      }
    }
  },
  mounted () {
    this.getTopArticles()
    this.getArticles()

    // 节流函数
    function throttle (func, wait, mustRun) {
      let timeout
      let startTime = new Date()

      return function () {
        let context = this
        let args = arguments
        let curTime = new Date()

        clearTimeout(timeout)
        // 如果达到了规定的触发时间间隔，触发 handler
        if (curTime - startTime >= mustRun) {
          func.apply(context, args)
          startTime = curTime
          // 没达到触发间隔，重新设定定时器
        } else {
          timeout = setTimeout(func, wait)
        }
      }
    }

    // 增加滚动监听
    this.$nextTick(function () {
      window.addEventListener('scroll', throttle(this.scroll, 100, 200))
      // 获取 进度点 的$el
      this.$dots = [this.$refs.dot1.$el, this.$refs.dot2.$el, this.$refs.dot3.$el, this.$refs.dot4.$el]
      this.$dots[0].classList.add('show')
      // 获取 手机版 good card 的$el
      this.$mobilecards = [this.$refs.goodcard.$refs.mobilecard0, this.$refs.goodcard.$refs.mobilecard1, this.$refs.goodcard.$refs.mobilecard2]
    })
  }
}
</script>
<style lang="stylus">

@keyframes up-down1
  0%
    transform: translate(0, 0) rotate(45deg)
  100%
    transform: translate(6px, 8px) rotate(40deg)

@keyframes up-down2
  0%
    transform: translate(0, 0) rotate(0deg)
  100%
    transform: translate(-6px, 3px) rotate(5deg)

@keyframes up-down3
  0%
    transform: translate(0, 0) scale(1)
  100%
    transform: translate(8px, 5px) scale(1.1)

@keyframes up-down4
  0%
    transform: translate(0, 0) rotate(150deg)
  100%
    transform: translate(5px, -3px) rotate(148deg)

@keyframes up-down5
  0%
    transform: translate(0, 0) rotate(250deg)
  100%
    transform: translate(5px, -3px) rotate(248deg)

@keyframes up-down-arrow
  0%
    transform: translate(0, 0) rotate(-15deg)
  100%
    transform: translate(5px, -10px) rotate(-15deg)

.clearfix
  clearfix()

// 使图片预览可以平滑滚动
.image-swiper-module
  .image-swiper-wrapper
    .swiper-container-free-mode > .swiper-wrapper
      -webkit-transition-timing-function linear !important
      -moz-transition-timing-function linear !important
      -ms-transition-timing-function linear !important
      -o-transition-timing-function linear !important
      transition-timing-function linear !important
      margin 0 auto !important

@media screen and (min-width: 1201px)
  .pc-only
    display block !important

  .mobile-only
    display none !important

  #home
    position relative
    margin auto
    background-color #000
    overflow hidden
    #long-bg
      position absolute
      top 876px
      left 0
      margin 0 auto
      width 100%
      z-index 0
    #left-star
      position absolute
      top 857px
      left 0
      width 677px
      height 1104px
      z-index 1
    #right-star
      position absolute
      top 1223px
      right 0
      width 606px
      height 1272px
      z-index 1
    #bottom-flag
      position absolute
      bottom 0
      left 0
      width 658px
      height 399px
    .page
      z-index 2
    #page1
      position relative
      height 715px
      margin-bottom 160px
      .center-box
        position relative
        margin 0 auto
        width 1199px
        height 100%
        #man-in-moon
          position absolute
          top 0
          right -121px
          #man
            position absolute
            top 134px
            right 121px
            width 573px
            height 520px
          #moon
            position absolute
            width 1135px
            height 598px
            top 0
            right 0
        #cool-title
          position absolute
          width 511px
          top 220px
          left 0
          .geekpark-logo
            position absolute
            top 0
            left 0
            width 157px
            height 30px
          .x-sign
            position absolute
            top 8px
            left 184px
            width 15px
            height @width
          .thinkpad-logo
            position absolute
            top 0
            left 225px
            width 99px
            height 30px
          #cool-bg
            position absolute
            top 51px
            left 0
            width 511px
            height 151px
          #cool-100
            position absolute
            top 154px
            left 0
            color #fff
            font-size 106px
            font-weight bold
            line-height @font-size
            white-space nowrap
          #cool-slogan
            position absolute
            top 281px
            left 0
            color #EB140A
            font-size 24px
            line-height 27px
        #three-point
          position absolute
          top 608px
          left 0
          width 100%
          height 200px
          br
            display none
          .block
            white-space nowrap
            &.left
              position absolute
              top 0
              left 0
              width 310px
            &.right
              position absolute
              top 0
              right 0
              width 170px
            &.center
              position relative
              margin 0 auto
              width 225px
              padding-left unit((310 - 170) / 2, 'px')
            .point
              color #EB140A
              font-size 64px
              font-weight bold
              line-height @font-size
              margin-bottom 16px
            .summary
              color #fff
              font-size 24px
              line-height 27px
      .dot-progress
        position absolute
        top 100px
        left 74px
        z-index 999
    #page2
      position relative
      height 800px
      margin-bottom 160px
      .decoration-block1
        position absolute
        top 443px
        left 372px
        width 400px
        height 300px
        z-index -1
        .item
          position absolute
          &.item1
            top 4px
            left 300px
            width 10px
            height 10px
            background-color #EB140A
            animation up-down1 3s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
          &.item2
            left 2px
            top 200px
            width 10px
            height 10px
            background-color #EB140A
            animation up-down2 2s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
          &.item3
            left 260px
            top 150px
            width 30px
            height 30px
            background-color #EB140A
            border-radius 50%
            animation up-down3 4s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
          &.item4
            left 380px
            top 290px
            width 0
            height 0
            border-width 0 9px 11px
            border-style solid
            border-color transparent transparent #EB140A /*透明 透明  灰*/
            animation up-down4 2s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
      .dot-progress-mobile
        position relative
        top 0
      .center-box
        position relative
        margin 0 auto
        width 1440px
        .left
          position relative
          left 264px
          top 200px
          width 305px
          white-space nowrap
          text-align left
          color #fff
          .title
            font-size 46px
            font-weight bold
            line-height 50px
            margin-bottom 10px
          .summary
            font-size 18px
            line-height 26px
            margin-bottom 80px
          .learn-more
            display block
            width 168px
            height 42px
            text-align center
            font-size 14px
            line-height @height
            border-radius 2px
            background-color #EB140A
            cursor pointer
            user-select none
            color #fff
            text-decoration none
            &:hover
              background-color darken(#EB140A, 10)
            &:active
              background-color darken(#EB140A, 20)
        .right
          position absolute
          top 0
          right 120px
          width 540px
          height @height
          z-index 10
          .article-swiper
            z-index 100
      .dot-progress
        position absolute
        top 0
        left 74px
        z-index 999
    #page3
      position relative
      height 840px
      margin-bottom 80px
      .center-box
        position relative
        margin 0 auto
        padding 0 120px
        max-width 1440px + @padding[1] * 2 px
        .title
          font-size 46px
          line-height @font-size
          margin-bottom 80px
          color #fff
        .good-card
          position relative
          margin 0 auto
      #four-point
        margin-bottom 81px
        .block
          float left
          width 25%
          text-align left
          .point
            color #EB140A
            font-size 18px
            line-height @font-size
            margin-bottom 10px
            padding 0 17px
          .summary
            color #fff
            font-size 14px
            line-height 22px
            padding 0 17px
      .dot-progress
        position absolute
        top 0
        left 74px
        z-index 999
    #page4
      position relative
      height 976px
      margin-bottom 160px
      .image-swiper
        padding-top 138px
        margin-bottom 80px
      .video-swiper
        margin-bottom 160px
      .dot-progress
        position absolute
        top 0
        left 74px
        z-index 999
    #footer
      position relative
      height 600px
      z-index 1
      .decoration-block1
        position absolute
        top -153px
        right 172px
        width 268px
        height 348px
        z-index -1
        .item
          position absolute
          &.item1
            top 240px
            left 240px
            width 10px
            height 10px
            background-color #EB140A
            animation up-down1 3s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
          &.item2
            left 50px
            top 2px
            width 10px
            height 10px
            background-color #EB140A
            animation up-down2 2s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
          &.item3
            left 70px
            top 220px
            width 30px
            height 30px
            background-color #EB140A
            border-radius 50%
            animation up-down3 4s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
          &.item4
            left 0
            top 358px
            width 0
            height 0
            border-width 0 9px 11px
            border-style solid
            border-color transparent transparent #EB140A /*透明 透明  灰*/
            transform
            animation up-down5 2s infinite
            animation-timing-function ease-in-out
            animation-direction alternate
      .qrcode
        margin-bottom 20px
        width 150px
        height @width
      .triangle
        width 30px
        height 18px
        margin-bottom 20px
      .tip
        font-size 24px
        line-height 29px
        margin-bottom 92px
      .bottom-slogan
        margin-bottom 42px
        font-size 24px
        font-weight bold
        line-height 30px
        .logo
          display inline-block
          width 75px
          height 22px
          line-height @line-height
          vertical-align middle
          padding-right 3px
        .red
          color #EB140A
      .social-icon
        position relative
        margin-bottom 42px
        img
          width 30px
          height @width
        .wechat-block
          display inline-block
          position relative
          margin-right 40px
          .wechat-qrcode
            position absolute
            left -65px
            top -180px
            border 3px solid #270c0b
            line-height 0
            img
              width 150px
              height @width
      .company-logo
        margin-bottom 43px
        .geekpark-logo
          width 108px
          height 20px
          margin-right 15px
        .x-sign
          width 13px
          height @width
          margin-right 14px
          padding 4px
        .thinkpad-logo
          width 66px
          height 20px
      .bg-line
        position absolute
        top 100px
        left 0
        width 100%
        height 196px
        background rgba(255, 255, 255, 0.15)
        z-index -1

@media screen and (min-width: 1201px) and (max-width: 1439px)
  #home
    #page1
      .center-box
        width auto
        #man-in-moon
          right 0
        #cool-title
          left 120px
        #three-point
          .block
            &.left
              left 120px
            &.right
              right 121px
    #page2
      .decoration-block1
        left 172px
      .center-box
        width auto
        .left
          left 200px
    #page3
      .center-box
        width auto

@media screen and (max-width: 1200px)
  .pc-only
    display none !important

  .mobile-only
    display block !important

  #home
    width 100%
    overflow hidden
    position relative
    background-color black
    background-image url("../assets/images/mobile/3-e5f9c89c8f.jpg")
    background-size 100% auto
    background-repeat repeat-y
    background-position 1.41 + 18.03rem 0 0 0
    #left-star1
      position absolute
      top 13.90rem
      left 0
      width 9.92rem
      height 20.23rem
    #right-star1
      position absolute
      top 45.32rem
      right 0
      width 9.41rem
      height 20.35rem
    #left-star2
      position absolute
      top 75.32rem
      left 0
      width 9.92rem
      height 20.23rem
    #right-star2
      position absolute
      top 100.32rem
      right 0
      width 9.41rem
      height 20.35rem
    #bottom-flag
      position absolute
      width 9.49rem
      height 6.24rem
      bottom 0
      left 0
    .dot-progress-mobile
      text-align left
      padding-left 0.94rem
      color #EB140A
      font-size 0.48rem
      line-height @font-size
      .dot
        position absolute
        left 0.64rem
        display block
        background-color #EB140A
        width 0.16rem
        height @width
        top unit((@line-height - @width) / 2, 'rem')
        border-radius 50%
        line-height 0
    .page
      position relative
    #mobile-header
      position relative
      width 100%
      height 1.41rem
      font-size 0.58rem
      line-height @height
      z-index 999
      .menu-button
        position absolute
        top 0
        right 0
        img
          width 0.8rem
          height 0.61rem
          padding 0.4rem 0.64rem
      .menu-wrapper
        position fixed
        width 100%
        top 0
        left 0
        bottom 0
        z-index 999
        background-color rgba(0, 0, 0, 0.5)
        .page
          border-bottom 1px solid #939393
          background-color #000
        .menu
          display block
          width 100%
          height 1.5rem
          color white
          text-decoration none
          text-align center
          line-height @height
          border-bottom 1px solid #939393
          background-color #000
    #page1
      height 18.03rem
      margin-bottom 2.4rem
      .center-box
        width auto
        #man-in-moon
          position absolute
          top 0
          right 0
          #man-mobile
            position absolute
            display block
            top 6.5rem
            right 0
            width 9.82rem
            height 9.87rem
          #moon-mobile
            position absolute
            display block
            top 3.52rem
            right 0
            width 12rem
            height 11.7rem
        #cool-title
          position relative
          width 100%
          top 0.54rem
          left 0
          .geekpark-logo
            position absolute
            top 0.04rem
            width 3.18rem
            height 0.63rem
            left 0.64rem
          .x-sign
            position absolute
            width 0.30rem
            height 0.30rem
            top 0.13rem
            left 4.39rem
          .thinkpad-logo
            position absolute
            width 2.02rem
            height 0.61rem
            left 5.20rem
          #cool-bg
            position absolute
            top 1.31rem
            left 0.64rem
            width 6.58rem
            height 1.94rem
          #cool-100
            position absolute
            top 2.19rem
            left 0.64rem
            font-size 2.19rem
            line-height @font-size
          #cool-slogan
            position absolute
            top 4.86rem
            left 0.64rem
            font-size 0.58rem
            line-height @font-size
            color #EB140A
        #three-point
          position absolute
          width 100%
          top 15.55rem
          height auto
          .block
            position relative !important
            float left !important
            left 0 !important
            right 0 !important
            margin 0 !important
            width 33% !important
            padding 0 !important
            br
              display inline-block
            .point
              font-size 1.31rem
              line-height 1.63rem
              color #EB140A
              margin-bottom 0.2rem
            .summary
              white-space nowrap
              margin 0 auto
              width 2.72rem
              font-size 0.38rem
              line-height 0.43rem
    #page2
      .center-box
        width auto
        padding 0 0.46rem
        text-align left
        .left
          position relative
          margin-top 0.18rem
          .title
            font-size 1.02rem
            line-height 1.12rem
          .summary
            margin-top 0.16rem
            font-size 0.42rem
            line-height 0.59rem
            br
              display none
          .articles
            margin-top 0.64rem
            margin-bottom 0.64rem
            a
              color #fff
              text-decoration none
            .article
              position relative
              width 10.72rem
              background-color rgba(255, 255, 255, 0.09)
              margin-bottom 0.32rem
              border-radius 0.15rem
              .title
                position relative
                padding-top 0.70rem
                padding-bottom 0.54rem
                padding-left 1.76rem
                width 8.1rem
                font-size 0.48rem
                line-height @font-size
                text-overflow ellipsis
                white-space nowrap
                overflow hidden
              .avatar
                position absolute
                top 0.48rem
                left 0.32rem
                width 1.12rem
                height @width
                border-radius 50%
                background-color red
              .summary
                position relative
                font-size 0.38rem
                width 10.07
                margin-left 0.32rem
                margin-right 0.32rem
                margin-bottom 0.32rem
              .time
                margin-left 0.32rem
                font-size 0.38rem
                line-height 0.53rem
                padding-bottom 0.48rem
          .learn-more
            margin 0 auto 2.37rem auto
            display block
            width 4.8rem
            height 1.41rem
            text-align center
            font-size 0.58rem
            line-height @height
            border-radius 0.1rem
            background-color #EB140A
            letter-spacing 0.2rem
            cursor pointer
            user-select none
            color #fff
            text-decoration none
            &:hover
              background-color darken(#EB140A, 10)
            &:active
              background-color darken(#EB140A, 20)
    #page3
      text-align left
      .center-box
        margin-bottom 2.34rem
        padding-left 0.64rem
        width 10.72rem
        .title
          font-size 1.02rem
          line-height 1.44rem
          margin-bottom 1.28rem
        #four-point
          .block
            margin-bottom 1.28rem
            .point
              color #EB140A
              font-size 0.48rem
              line-height 0.67rem
              margin-bottom 0.16rem
            .summary
              font-size 0.38rem
              line-height 0.58rem
    #page4
      margin-bottom 2.37rem
      .image-swiper
        margin-top 0.64rem
      .video-swiper
        margin-top 0.76rem
    #footer
      position relative
      .bg-line
        position absolute
        top 1.6rem
        left 0
        display block
        width 100%
        height 2.98rem
        background-color rgba(255, 255, 255, 0.15)
      .qrcode-wrapper
        position relative
        height 2.4rem
        margin-bottom 0.32rem
        .qrcode
          width @height
          height @height
      .triangle-wrapper
        position relative
        height 0.29rem
        margin-bottom 0.32rem
        .triangle
          margin 0 auto
          display block
          width 0.4rem
          height @height
      .tip
        font-size 0.38rem
        line-height 0.46rem
        margin-bottom 2.7rem
      .social-icon
        position relative
        margin-bottom 1.2rem
        img
          width 0.96rem
          height @width
        .wechat-block
          display inline-block
          position relative
          margin-right 1.28rem
          .wechat-qrcode
            position absolute
            left -1.20 rem
            top -3.66rem
            border 0.03rem solid #270c0b
            line-height 0
            img
              width 3.2rem
              height @width
      .bottom-slogan
        font-size 0.69rem
        line-height 0.69rem
        font-weight bold
        margin-bottom 1.28rem
        .logo
          width 2.16rem
          height 0.64rem
          vertical-align middle
        .red
          color #EB140A
      .company-logo
        img
          display block
          margin 0 auto
        .geekpark-logo
          width 3.46rem
          height 0.64rem
          margin-bottom 0.4rem
        .x-sign
          width 0.3rem
          height @width
          margin-bottom 0.4rem
        .thinkpad-logo
          width 2.11rem
          height 0.64rem
          margin-bottom 0.94rem

  .wechat-share-tip
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 9999
    background-color rgba(0, 0, 0, 0.51)
    .content
      position absolute
      width 100%
      text-align center
      top 3rem
      font-size 0.8rem
    .arrow
      position absolute
      top 0.8rem
      right 0.8rem
      width 1.5rem
      height @width
      animation up-down-arrow 1s infinite
      animation-timing-function ease-in-out
      animation-direction alternate
      img
        width @width
        height @height
</style>



// WEBPACK FOOTER //
// src/views/Home.vue